var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarwh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4752 13.025L42.0001 20.075C42.4751 21.05 43.7501 21.975 44.8251 22.175L51.2001 23.225C55.2751 23.9 56.2251 26.85 53.3001 29.8L48.3251 34.775C47.5001 35.6 47.0252 37.225 47.3002 38.4L48.7251 44.55C49.8501 49.4 47.2501 51.3 42.9751 48.75L37.0001 45.2C35.9251 44.55 34.1251 44.55 33.0501 45.2L27.0751 48.75C22.8001 51.275 20.2001 49.4 21.3251 44.55L22.7501 38.4C23.0251 37.25 22.5501 35.625 21.7251 34.775L16.7502 29.8C13.8252 26.875 14.7751 23.925 18.8501 23.225L25.2251 22.175C26.3001 22 27.5751 21.05 28.0501 20.075L31.5751 13.025C33.4501 9.2 36.5502 9.2 38.4752 13.025Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5H5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 47.5H5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 30H5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarwh);
export default __webpack_public_path__ + "static/media/starwh.42df0c3ef60cad78393e29814cfb2a31.svg";
export { ForwardRef as ReactComponent };